import {Directive, HostListener} from '@angular/core';

@Directive({
  selector: '[appNumericInput]'
})
export class NumericInputDirective {
  @HostListener('keydown', ['$event'])
  isNumericInput(event: KeyboardEvent): boolean {
    const charCode = event.which ?? event.keyCode;

    if (
      [8, 9, 13, 27, 46].includes(charCode) ||
      ((event.ctrlKey || event.metaKey) && [65, 67, 86, 88].includes(charCode))
    ) {
      return true;
    }

    const result = (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105);

    if (!result) {
      event.preventDefault();
    }

    return result;
  }
}
